import {
  addDays,
  subDays,
  addYears,
  subYears,
  endOfToday,
  startOfToday,
} from 'date-fns';

import { formatFristDayToStandard, isValidDate } from '@utils/formatIfDate';

const tomorrow = addDays(startOfToday(), 1);
const yesterday = subDays(endOfToday(), 1);

export const requirements = {
  document_expiration_date: {
    minDate: tomorrow,
    minDateMsg: 'date_min_error_msg',
    maxDate: addYears(endOfToday(), 100),
    maxDateMsg: 'date_max_error_msg',
  },
  document_issue_date: {
    minDate: subYears(endOfToday(), 100),
    minDateMsg: 'date_min_error_msg',
    maxDate: yesterday,
    maxDateMsg: 'date_max_error_msg',
  },
  birth_date: {
    minDate: subYears(endOfToday(), 100),
    minDateMsg: 'date_min_error_msg',
    maxDate: yesterday,
    maxDateMsg: 'date_max_error_msg',
  },
};

export const validateField = (name) => (value) => {
  let error;
  if (!value) {
    // error = 'required_field';
    return error;
  }
  const isValid = isValidDate(value);
  if (!isValid) {
    error = 'date_format';
    return error;
  }

  const date = new Date(formatFristDayToStandard(value));

  const checkMindate = requirements[name] && requirements[name].minDate;
  if (checkMindate && date.getTime() < requirements[name].minDate.getTime()) {
    error = requirements[name].minDateMsg;
    return error;
  }

  const checkMaxdate = requirements[name] && requirements[name].maxDate;
  if (checkMaxdate && date.getTime() > requirements[name].maxDate.getTime()) {
    error = requirements[name].maxDateMsg;
    return error;
  }

  return error;
};
